import { useCallback } from 'react';
import { useApi } from './useApi';
import { useApiAction } from './useApiAction';

/**
 * The team invoice celebration: every invoice sent since this user last saw the
 * modal, whoever sent it. Delivered on app load rather than at send time, so the
 * whole team sees the win together rather than only the person who clicked.
 */
export function useInvoiceCelebrations() {
  const { apiCall } = useApi();

  const [fetchCelebrations, loading] = useApiAction(
    useCallback(async (api) => {
      return api('customer-invoices-celebrations-list');
    }, []),
    apiCall
  );

  const [acknowledgeCelebrations] = useApiAction(
    useCallback(async (api, seenThrough) => {
      return api('customer-invoices-celebrations-ack', {
        method: 'POST',
        body: JSON.stringify({ seenThrough }),
      });
    }, []),
    apiCall
  );

  return { fetchCelebrations, acknowledgeCelebrations, loading };
}
